import { rangeBounds, sortItems } from '@/utils/filters';

export const sortColumnOptions = [
  { value: 'created', label: 'Created' },
  { value: 'updated', label: 'Modified' },
  { value: 'name', label: 'Name', defaultDirection: 'asc' },
  { value: 'time', label: 'Cook time' },
];

export const DEFAULT_SORT_COLUMN = 'updated';

export const RANGE_FILTERS = [
  { key: 'calories', label: 'Calories per serving', unit: 'kcal' },
  { key: 'totalTime', label: 'Total time', unit: 'min' },
  { key: 'prepTime', label: 'Prep time', unit: 'min' },
  { key: 'cookTime', label: 'Cook time', unit: 'min' },
];

export function countActiveFilters(filters) {
  return filters.tags.length
    + filters.ingredients.length
    + RANGE_FILTERS.filter((range) => filters[range.key] !== null).length;
}

const sortValueGetters = {
  created: (recipe) => new Date(recipe.created),
  updated: (recipe) => new Date(recipe.updated),
  name: (recipe) => recipe.name.toLowerCase(),
  time: (recipe) => recipe.prep_time + recipe.cook_time,
};

export function sortRecipes(recipes, sort) {
  return sortItems(recipes, sort, sortValueGetters, DEFAULT_SORT_COLUMN);
}

export function filterRecipes(recipes, filters, favoriteIds) {
  return recipes.filter((recipe) => {
    let matches = true;

    if (filters.search !== '') {
      matches &= recipe.name.toLowerCase().includes(filters.search.toLowerCase());
    }

    if (filters.categories.length > 0) {
      matches &= filters.categories.some((category) => recipe.categories.includes(category));
    }

    if (filters.tags.length > 0) {
      matches &= filters.tags.some(filterTag =>
        recipe.tags?.some(recipeTag => recipeTag === filterTag)
      );
    }

    if (filters.ingredients.length > 0) {
      matches &= filters.ingredients.some(filterIngredient =>
        recipe.ingredients?.some(recipeIngredient => recipeIngredient.toLowerCase() === filterIngredient.toLowerCase())
      );
    }

    if (filters.favorites) {
      matches &= favoriteIds.has(recipe.id);
    }

    if (filters.tried) {
      matches &= recipe.tried;
    }

    if (filters.prepTime) {
      matches &= recipe.prep_time >= filters.prepTime[0] && recipe.prep_time <= filters.prepTime[1];
    }

    if (filters.cookTime) {
      matches &= recipe.cook_time >= filters.cookTime[0] && recipe.cook_time <= filters.cookTime[1];
    }

    if (filters.totalTime) {
      const totalTime = recipe.prep_time + recipe.cook_time;
      matches &= totalTime >= filters.totalTime[0] && totalTime <= filters.totalTime[1];
    }

    if (filters.calories && recipe.nutrition) {
      matches &= recipe.nutrition.kcal >= filters.calories[0] && recipe.nutrition.kcal <= filters.calories[1];
    }

    return matches;
  });
}

export function computeRecipeBounds(recipes) {
  return {
    prepTime: rangeBounds(recipes.map((recipe) => recipe.prep_time)),
    cookTime: rangeBounds(recipes.map((recipe) => recipe.cook_time)),
    totalTime: rangeBounds(recipes.map((recipe) => recipe.prep_time + recipe.cook_time)),
    calories: rangeBounds(recipes.map((recipe) => recipe.nutrition?.kcal)),
  };
}
